export default function nowValueThatCanBeStubbedInTests(): Date {
  return new Date(Date.now());
}
